/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".csv-select.text-grey[_ngcontent-%COMP%]{color:#a9a9a9!important}.csv-select[_ngcontent-%COMP%]:focus{color:#495057!important}"];
export { styles as styles };
